import { Component, Input, OnInit } from '@angular/core';
import { CompleteFormService } from 'src/app/services/api/complete-form.service';
import { GlobalService } from 'src/app/services/index.service';

@Component({
  selector: 'app-results',
  templateUrl: './results.component.html',
  styleUrls: ['./results.component.scss']
})
export class ResultsComponent {
  @Input() data:any
  @Input() user:any

  constructor(
    private completeForm:CompleteFormService,
  ){}

  ngOnDestroy(){
    this.completeForm.setBackButton(null)
  }
}
